export type LegalCompanyInfo = {
    companyName: string;
    address: string;
    footerAddress: string;
    footerRegistration: string;
};

export type GoverningLawInfo = {
    governingLaw: string;
    courts: string;
};

export type LegalProfile = LegalCompanyInfo & {
    jurisdiction: string;
    registrationSuffix: string;
    companyRegistrationText: string;
    personalDataControllerText: string;
    legalEntityRegistrationText: string;
};

const CYPRUS_ADDRESS =
    "28 Oktovriou, 317A KANIKA BUSINESS CENTER, Block B, 1st floor, Flat/Office 101, 3105, Limassol, Cyprus";
const US_REGISTERED_ADDRESS = "30 N Gould St Ste 46968, Sheridan, WY, 82801, USA";
const US_FOOTER_ADDRESS = "2240 E 12th Street Suite 100, Casper, Wyoming 82609, USA";

export const DEFAULT_LEGAL_PROFILE: LegalProfile = {
    companyName: "GITMIX LIMITED",
    address: CYPRUS_ADDRESS,
    footerRegistration: 'ΗΕ465305',
    footerAddress: CYPRUS_ADDRESS,
    jurisdiction: "Cyprus",
    registrationSuffix: " (Reg. No.: 465305)",
    companyRegistrationText: "a company registered in Cyprus (reg. number: 465305)",
    personalDataControllerText:
        " incorporated under the laws of Cyprus under number HE 465305 and having its office at ",
    legalEntityRegistrationText: "registered under the laws of Cyprus, registration number 465305"
};

export const US_LEGAL_PROFILE: LegalProfile = {
    companyName: "Tixu LLC",
    address: US_REGISTERED_ADDRESS,
    footerAddress: US_FOOTER_ADDRESS,
    footerRegistration: '',
    jurisdiction: "USA",
    registrationSuffix: " (reg. No.: 2026-001928281)",
    companyRegistrationText: "a company registered in USA (reg. number: 2026-001928281)",
    personalDataControllerText:
        " incorporated under the laws of USA under reg. number: 2026-001928281 and having its office at ",
    legalEntityRegistrationText: "registered under the laws of USA, registration number 2026-001928281"
};

const US_LEGAL_COUNTRY_CODES = new Set(["US"]);

export const isUsLegalCountry = (countryCode?: string): boolean =>
    US_LEGAL_COUNTRY_CODES.has((countryCode || "").toUpperCase());

export const getLegalProfileByCountry = (countryCode?: string): LegalProfile => {
    if (isUsLegalCountry(countryCode)) return US_LEGAL_PROFILE;
    return DEFAULT_LEGAL_PROFILE;
};

export const getLegalCompanyInfoByCountry = (countryCode?: string): LegalCompanyInfo => {
    const { companyName, address, footerAddress, footerRegistration } = getLegalProfileByCountry(countryCode);
    return { companyName, address, footerAddress, footerRegistration };
};

export const getGoverningLawInfoByCountry = (countryCode?: string): GoverningLawInfo => {
    const { jurisdiction } = getLegalProfileByCountry(countryCode);
    return { governingLaw: jurisdiction, courts: jurisdiction };
};
